import {
  formSpecification as commonFormSpecification,
  type RequestPolicePresenceMainFormData as CommonRequestPolicePresenceMainFormData,
} from "../common/requestPolicePresenceMain.js";

export const formSpecification = commonFormSpecification;

export type RequestPolicePresenceMainFormData =
  CommonRequestPolicePresenceMainFormData;
